import { Controller } from "@hotwired/stimulus"
import { notifyNetworkError } from "../../application/wv/api/utils"

export default class extends Controller {
  static targets = ["button"]
  static values = { url: String, failureMessage: String, loadingLabel: String }

  initialize() {
    this.confirmed = false
    this.submitting = false
  }

  reset() {
    this.confirmed = false
  }

  async submit(event) {
    event.preventDefault()

    if (this.submitting) {
      return
    }

    if (!this.confirmed) {
      this.confirmed = true
      return
    }

    this.submitting = true
    this.startLoading()

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "X-CSRF-Token": csrfToken ?? "",
          "Accept": "text/html",
        },
      })
      if (!response.ok) {
        throw new Error(`Close request failed with status ${response.status}`)
      }
      window.location.reload()
    } catch (error) {
      this.confirmed = false
      this.submitting = false
      this.stopLoading()
      this.application
        .getControllerForElementAndIdentifier(this.element, "confirm")
        ?.deny()
      notifyNetworkError(this.failureMessageValue)
      throw error
    }
  }

  startLoading() {
    if (!this.hasButtonTarget) return
    this.originalButtonText = this.buttonTarget.textContent
    if (this.loadingLabelValue) {
      this.buttonTarget.textContent = this.loadingLabelValue
    }
    this.buttonTarget.style.opacity = "0.6"
    this.buttonTarget.style.pointerEvents = "none"
    this.buttonTarget.setAttribute("aria-busy", "true")
  }

  stopLoading() {
    if (!this.hasButtonTarget) return
    if (this.originalButtonText != null) {
      this.buttonTarget.textContent = this.originalButtonText
      this.originalButtonText = null
    }
    this.buttonTarget.style.opacity = ""
    this.buttonTarget.style.pointerEvents = ""
    this.buttonTarget.removeAttribute("aria-busy")
  }
}
